export const UPDATE_TIMEBAR_MODE = 'update-timebar-mode';
export const UPDATE_TIMEBAR_ENABLE_TIMESTAMP = 'update-timebar-enable-timestamp';
export const UPDATE_TIMEBAR_SPEED = 'update-timebar-speed';
export const UPDATE_TIMEBAR_PLAY = 'update-timebar-play';
export const UPDATE_TIMEBAR_LOOP = 'update-timebar-loop';
export const UPDATE_TIMEBAR_PLAYHEAD_START = 'update-timebar-playhead-start';
export const UPDATE_TIMEBAR_INTERVAL = 'update-timebar-play-interval';

export const updateTimebarMode = props => ({
    ...props,
    type: UPDATE_TIMEBAR_MODE
});

export const updateTimebarEnableTimestamp = props => ({
    ...props,
    type: UPDATE_TIMEBAR_ENABLE_TIMESTAMP
});

export const updateTimebarSpeed = props => ({
    ...props,
    type: UPDATE_TIMEBAR_SPEED
});

export const updateTimebarPlay = props => ({
    ...props,
    type: UPDATE_TIMEBAR_PLAY
});

export const updateTimebarLoop = props => ({
    ...props,
    type: UPDATE_TIMEBAR_LOOP
});

export const updateTimebarPlayheadStart = props => ({
    ...props,
    type: UPDATE_TIMEBAR_PLAYHEAD_START
});

export const updateTimebarInterval = props => ({
    ...props,
    type: UPDATE_TIMEBAR_INTERVAL
});